module.exports = __webpack_public_path__ + "6163f5c3615f82636afbb94d49a19a3e.png";